<template>
  <div class="center">
    <img src="@/assets/img/download/downloadTitle.jpg" style="width:100%" />
    <div class="title">
      <img src="@/assets/img/download/logo.png" style="width:70px;height:70px" />
      <div class="titleContent">
        <div class="titleDiv">
          <div class="titleDivT">中国旅游TV</div>
          <div class="titleDivBtn">官方</div>
        </div>
        <div class="titleTip">
          <span style="margin-right:5px">3.5分</span>
          <span style="margin-right:5px">2.3亿次下载</span>
          <span style="margin-right:5px">60.25MB</span>
        </div>
      </div>
    </div>
    <div class="contentSpace"></div>
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick" :stretch="true">
        <el-tab-pane label="详情" name="first">
          <div style="padding:0px 15px;margin-bottom:60px">
            <div style="font-size:20px;margin-bottom:10px">简介</div>
            <div>中国旅游TV手机APP是中国旅游影视传媒有限公司旗下研发的荣誉产品，该产品集合高清在线视频观看、实时网络直播互动、旅游资讯分享、活动信息公布、城市旅游服务、旅游在线交友等功能于一体。是城市旅游宣传、景区旅游推广、旅游商业活动推广、个人旅游信息交流的优质平台。</div>
            <div style="font-size:20px;margin:20px 0px 10px">软件截图</div>
            <img src="@/assets/img/download/downloadImg.png" style="width:100%" />
          </div>
        </el-tab-pane>
        <el-tab-pane label="评论" name="second">
          <div class="comment">
            <div class="totalGrade">
              <span style="font-size:20px">综合评分:</span>
              <span style="font-size:20px;color:#169bd5;margin:0px 5px;font-weight:bold">5.0</span>
              <img src="@/assets/img/download/starFull.png" style="width:20px" />
              <img src="@/assets/img/download/starFull.png" style="width:20px" />
              <img src="@/assets/img/download/starFull.png" style="width:20px" />
              <img src="@/assets/img/download/starFull.png" style="width:20px" />
              <img src="@/assets/img/download/starFull.png" style="width:20px" />
            </div>
            <div class="commentList">
              <div style="font-size:18px">热门评论</div>
              <div>
                <div style="display:flex;justify-content:space-between;padding:10px 0px">
                  <div style="display:flex">
                    <img src="@/assets/img/download/userCover.png" style="width:50px" />
                    <div style="padding-left:20px">
                      <div>中国旅游TV忠实用户</div>
                      <div>
                        <img src="@/assets/img/download/starFull.png" style="width:10px" />
                        <img src="@/assets/img/download/starFull.png" style="width:10px" />
                        <img src="@/assets/img/download/starFull.png" style="width:10px" />
                        <img src="@/assets/img/download/starFull.png" style="width:10px" />
                        <img src="@/assets/img/download/starFull.png" style="width:10px" />
                        <span style="margin-left:20px;font-size:14px">2019-12-5</span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <img src="@/assets/img/download/zan.png" style="width:20px" />
                    226
                  </div>
                </div>
                <div style="border-bottom:1px solid #e7e7e7;padding-bottom:15px">
                  很好用的软件,棒!
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="footer">
      <div class="footerBtn" @click="download">下载(60.25MB)</div>
    </div>
    <!-- <div style="margin-top:40px">
      <img src="@/assets/head.png" style="width:220px" />
    </div>
    <div class="dbox" v-if="device == 'desktop' || device == 'android'">
      <div style="margin-top:40px">
        <span class="title">中国旅游TV 安卓版</span>
      </div>
      <div class="download-btn">
        <el-button type="success" round>
          <div @click="download('android')">下载</div>
        </el-button>
      </div>
    </div>

    <div class="dbox" v-if="device == 'desktop' || device == 'ios'">
      <div style="margin-top:40px">
        <span class="title">中国旅游TV 苹果版</span>
      </div>
      <div class="download-btn">
        <el-button type="success" round>
          <div @click="download('android')">下载</div>
        </el-button>
      </div>
    </div>-->
  </div>
</template>

<script>
import { isIOS, isAndroid, getUA } from "mobile-device-detect";
import request, { getVersion } from "@/utils/request.js";

export default {
  head() {
    return {
      title: "下载APP-",
    };
  },
  components: {},
  data() {
    return {
      VUE_APP_BASE_API: process.env.VUE_APP_BASE_API,
      activeName: "first",
      device: "",
      androidUrl: "https://www.my100000.com:9080/pkgs/app-cntravel-release.1.2.3.0060.apk",
      iosUrl: "https://apps.apple.com/cn/app/中国旅游tv/id1131237311",
    };
  },
  methods: {
    handleClick(){},
    download() {
      if (getUA.toLowerCase().indexOf("micromessenger") > -1) {
        this.$notify({
          title: "下载APP",
          message: "请点击右上角，选择在浏览器打开",
        });
        return;
      }
      if (this.device == "android") {
        window.location.href = "zgly://";
        setTimeout(()=> {
          let hidden =
            window.document.hidden ||
            window.document.mozHidden ||
            window.document.msHidden ||
            window.document.webkitHidden;
          if (typeof hidden == "undefined" || hidden == false) {
            window.location.href = this.androidUrl;
          }
        }, 2000);
      } else {
        window.location.href = "zgly://";
        setTimeout(()=> {
          let hidden =
            window.document.hidden ||
            window.document.mozHidden ||
            window.document.msHidden ||
            window.document.webkitHidden;
            console.log(hidden)
          if (typeof hidden == "undefined" || hidden == false) {
            //App store下载地址
            window.location.href = this.iosUrl;
          }
        }, 2000);
      }
    },
  },
  mounted() {
    if (isIOS) {
      // ios系统的处理
      this.device = "ios";
    } else if (isAndroid) {
      // Android系统的处理
      this.device = "android";
    } else {
      // unknown
      this.device = "desktop";
    }

    getVersion().then((res) => {
      res.data.forEach((v) => {
        if (v.equipment == "ANDROID") {
          // this.androidUrl = this.VUE_APP_BASE_API + v.localUrl;
          //this.androidUrl = v.storeUrl
        } else if (v.equipment == "IOS") {
          this.iosUrl = v.storeUrl;
        }
      });
    });
  },
};
</script>

<style lang="less">
.center {
  .title {
    margin-top: 20px;
    margin-bottom: 15px;
    display: flex;
    padding: 0px 15px;
    .titleContent {
      margin-left: 15px;
      padding: 10px 0px;
      display: flex;
      justify-content: space-around;
      flex-direction: column;
      .titleDiv {
        display: flex;
        align-items: center;
        .titleDivT {
          font-weight: bold;
          font-size: 22px;
        }
        .titleDivBtn {
          background-color: rgba(22, 155, 213, 1);
          font-size: 14px;
          color: #fff;
          width: 50px;
          height: 20px;
          text-align: center;
          border-radius: 5px;
          margin-left: 10px;
        }
      }
    }
  }
  .contentSpace {
    background: rgba(242, 242, 242, 1);
    height: 10px;
    width: 100%;
  }
  .comment {
    .totalGrade {
      padding: 0px 20px 20px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e7e7e7;
    }
    .commentList {
      padding: 20px 20px 0px;
    }
  }
  .footer {
    position: fixed;
    bottom: 0px;
    height: 56px;
    width: 100%;
    .footerBtn {
      color: #fff;
      background: rgba(22, 155, 213, 1);
      margin: auto;
      height: 50px;
      line-height: 50px;
      text-align: center;
      border-radius: 10px;
      width: 90%;
    }
  }
}

.dbox {
  width: 300px;
  height: 300px;
  text-align: center;
  display: inline-block;
  margin: 100px 50px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.dbox .title {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 26px;
  color: #333;
  font-weight: 100;
}

.dbox .download-btn {
  margin-top: 30px;
  button {
    width: 80%;
  }
}

@media screen and (max-width: 560px) {
  .center {
    width: 100%;
    height: 100%;
  }
  .dbox {
    margin: 30px 50px;
  }
}
</style>
